import { Role } from '@okletsplay/core';
import { Route } from 'app/enums';
import { GuardedRoute } from 'app/interfaces/route';
import { rolesGuard } from 'app/routing/guards';
import { lazyRetry } from 'app/utils';
import { AdminRoutes } from 'modules/admin/routes';
import { GameStatisticsRoutes } from 'modules/game-statistics/routes';
import { GameRoutes } from 'modules/games/routes';
import { MatchesRoutes } from 'modules/matches/routes';
import { TournamentsRoutes } from 'modules/tournaments/routes';
import { UsersRoutes } from 'modules/users/routes';
import { PlatformLinkingRoutes } from 'modules/platform-linking/routes';
import { AffiliateProgramsRoutes } from 'modules/affiliate-programs/routes';

const Home = lazyRetry(() => import('modules/home/pages/HomePage'));
const TournamentSuccess = lazyRetry(() => import('shared/components/Tournament/TournamentSuccess'));
const AdminTournamentSuccess = lazyRetry(
  () => import('shared/components/Tournament/AdminTournamentSuccess')
);
const UserDetail = lazyRetry(() => import('container/Pages/ManageUser/UserDetail'));
const TransactionHistory = lazyRetry(() => import('container/Pages/TransactionHistory'));
const ManageTournamentDetail = lazyRetry(
  () => import('container/Pages/ManageTournament/ManageTournamentDetail')
);

// TODO: move other routes to the separate modules
export const ROUTES: GuardedRoute[] = [
  {
    path: Route.Home,
    name: 'Home',
    component: Home,
    availability: [],
    guards: [],
  },
  {
    path: Route.TournamentSuccess,
    name: 'Tournament Success',
    component: TournamentSuccess,
    availability: [Role.User, Role.TournamentCreator],
    guards: [rolesGuard([Role.User, Role.TournamentCreator])],
  },
  {
    path: Route.AdminTournamentSuccess,
    name: 'Admin Tournament Success',
    component: AdminTournamentSuccess,
    availability: [Role.User, Role.TournamentAdministrator],
    guards: [rolesGuard([Role.User, Role.TournamentAdministrator])],
  },
  {
    path: Route.UserDetails,
    name: 'User Detail',
    component: UserDetail,
    availability: [Role.User, Role.UserAdministrator],
    guards: [rolesGuard([Role.User, Role.UserAdministrator])],
  },
  {
    path: Route.TransactionHistory,
    name: 'Transaction History',
    component: TransactionHistory,
    availability: [Role.User],
    guards: [rolesGuard([Role.User])],
  },
  {
    path: Route.ManageTournamentDetails,
    name: 'Manage Tournament Detail',
    component: ManageTournamentDetail,
    availability: [Role.User, Role.TournamentAdministrator],
    guards: [rolesGuard([Role.User, Role.TournamentAdministrator])],
  },
  ...PlatformLinkingRoutes,
  ...GameRoutes,
  ...MatchesRoutes,
  ...TournamentsRoutes,
  ...UsersRoutes,
  ...AdminRoutes,
  ...GameStatisticsRoutes,
  ...AffiliateProgramsRoutes,
];
